import { render, staticRenderFns } from "./GradeProductItemForm.vue?vue&type=template&id=1fe99204"
import script from "./GradeProductItemForm.vue?vue&type=script&lang=js"
export * from "./GradeProductItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports